import { useEffect } from 'react';
import { useSearchParams } from 'react-router-dom';
import { MessageActions } from './types';
import { getViewFieldComponent } from './page/view';


function App() {
  const [search] = useSearchParams();
  const session = search.get('session') ?? '';
  const fieldType = search.get('field') ?? '';
  const libInitializeId = search.get('libInitializeId') ?? '';

  useEffect(() => {
    window.parent.postMessage({
      action: MessageActions.IFRAME_LOADED,
      field: fieldType,
      sessionId: session,
      libInitializeId,
    }, '*');
  }, []);

  return (<>
    {getViewFieldComponent(fieldType)}
  </>);
}

export default App;
